import styled from 'styled-components'

const StyledSearchHighlightedSpan = styled.span`
  background-color: ${({ theme }) => theme.colors.purple};
`

export default StyledSearchHighlightedSpan
